import { gql } from '@apollo/client';

export const WEB_PAGE_QUERY = gql`
  query WebPage($url: String) {
    webPage(url: $url) {
      appName
      slug
      checkoutUrl
      colorTheme
      supportEmail

      logo {
        url
      }
      trainer {
        _id
        name
      }

      heroSection {
        title
        subtitle
        ctaButtonText
        ctaButtonLink
        imageUrl
      }
      appDownloadSection {
        title
        subtitle
        ctaButtonText
        ctaButtonLink
        imageUrl
        appleAppStoreLink
        googlePlayStoreLink
      }
      featuresSection {
        title
        imageUrl
        features {
          title
          subtitle
        }
      }
      workoutsSection {
        title
        workouts {
          _id
          title
          coverImageUrl(width: 400, height: 400)
        }
        trainingPlans {
          _id
          title
          coverImageUrl(width: 400, height: 400)
        }
      }
      testimonialsSection {
        testimonials {
          name
          quote
          imageUrl
        }
      }
      aboutSection {
        content
        imageUrl
      }
      footerSection {
        appleAppStoreLink
        googlePlayStoreLink
        links {
          title
          url
        }
      }
      updatedAt
      createdAt
    }
  }
`;
